<form-popup [(visible)]="visible" (save)="onPopupSaveClick()" (visibleChange)="onVisibleChange($event)" titleText="New Shift">
    <shift-form [data]=""></shift-form>
</form-popup>
